import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-red-600 to-red-700 text-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Terms and Conditions</h1>
          <p className="text-xl text-red-100">Last updated: January 2026</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">Agreement to Terms</h2>
            <p className="text-gray-700 mb-6">
              These Terms and Conditions constitute a legally binding agreement between you and Madilu Retail Private
              Limited ("IndyaNet," "we," "our," or "us") concerning your access to and use of our website and
              services.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Use of Our Services</h2>
            <p className="text-gray-700 mb-4">By using our services, you agree to:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
              <li>Provide accurate and complete information when requested</li>
              <li>Use our services only for lawful purposes</li>
              <li>Not interfere with or disrupt the integrity or performance of our services</li>
              <li>Comply with all applicable laws and regulations</li>
            </ul>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Service Terms</h2>
            <p className="text-gray-700 mb-6">
              Our network solutions and services are provided subject to availability and in accordance with the specific
              service agreements entered into with each customer. Service levels, pricing, and terms may vary based on
              the selected package and customer requirements.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Intellectual Property Rights</h2>
            <p className="text-gray-700 mb-6">
              Unless otherwise indicated, our website and all content, features, and functionality are owned by Madilu
              Retail Private Limited and are protected by international copyright, trademark, and other intellectual
              property laws.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Limitation of Liability</h2>
            <p className="text-gray-700 mb-6">
              To the fullest extent permitted by applicable law, IndyaNet shall not be liable for any indirect,
              incidental, special, consequential, or punitive damages, including without limitation, loss of profits,
              data, use, or other intangible losses, resulting from your access to or use of our services.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Service Availability</h2>
            <p className="text-gray-700 mb-6">
              While we strive to provide uninterrupted service, we do not guarantee that our services will be available
              at all times. We may experience hardware, software, or other problems or need to perform maintenance
              related to the services, resulting in interruptions, delays, or errors.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Termination</h2>
            <p className="text-gray-700 mb-6">
              We may terminate or suspend your access to our services immediately, without prior notice or liability, for
              any reason whatsoever, including without limitation if you breach these Terms and Conditions.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Governing Law</h2>
            <p className="text-gray-700 mb-6">
              These Terms shall be governed and construed in accordance with the laws of India, without regard to its
              conflict of law provisions. Any disputes arising from these terms shall be subject to the exclusive
              jurisdiction of the courts in Bengaluru, Karnataka.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Changes to Terms</h2>
            <p className="text-gray-700 mb-6">
              We reserve the right to modify or replace these Terms at any time. If a revision is material, we will
              provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change
              will be determined at our sole discretion.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Contact Information</h2>
            <p className="text-gray-700">
              If you have any questions about these Terms and Conditions, please contact us:
            </p>
            <div className="mt-4 text-gray-700">
              <p>
                <strong>Madilu Retail Private Limited</strong>
              </p>
              <p>No.591, 2nd Floor, 14th Main Road, 15th Cross Rd</p>
              <p>4th Sector, HSR Layout, Bengaluru, Karnataka 560102</p>
              <p className="mt-2">
                Phone: <a href="tel:+917411954841" className="text-red-600 hover:text-red-700">+91 7411954841</a>
              </p>
              <p>
                Email: <a href="mailto:support@indyanet.com" className="text-red-600 hover:text-red-700">support@indyanet.com</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;